import { useState, useEffect, useCallback } from 'react';
import { adminSelectionService } from '../service/adminSelectionService.mjs';



export const useStats = () => {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const loadStats = useCallback(async () => {
        try {
            setLoading(true);
            const response = await adminSelectionService.getStats();
            if (response.success) {
                setStats(response.data);
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to load statistics');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        loadStats();
    }, [loadStats]);

    return {
        stats,
        loading,
        error,
        refetch: loadStats
    };
};




